module.exports = __webpack_public_path__ + "static/media/womanInLogo.6bba7995.png";